// Utility function to handle column reordering
export const reorderColumns = (columns) => {
  // Find Done column
  const doneIndex = columns.findIndex(col => 
    col.label?.toLowerCase() === 'done' || 
    col.label?.toLowerCase() === 'fini' || 
    col.value === 'done' ||
    col.label?.toLowerCase() === 'terminé'
  );
  
  if (doneIndex === -1) return columns; // No Done column found
  
  // If Done is not last, move it to the end
  if (doneIndex !== columns.length - 1) {
    const reordered = [...columns];
    const doneColumn = reordered.splice(doneIndex, 1)[0];
    reordered.push(doneColumn);
    
    // Update order indices
    return reordered.map((col, idx) => ({ ...col, order: idx }));
  }
  
  return columns;
};

// Insert new column before Done column
export const insertColumnBeforeDone = (columns, newColumn) => {
  const doneIndex = columns.findIndex(col => 
    col.label?.toLowerCase() === 'done' || 
    col.label?.toLowerCase() === 'fini' || 
    col.value === 'done' ||
    col.label?.toLowerCase() === 'terminé'
  );
  
  const insertIndex = doneIndex !== -1 ? doneIndex : columns.length;
  const newColumns = [...columns];
  newColumns.splice(insertIndex, 0, {
    ...newColumn,
    order: insertIndex
  });
  
  // Update order indices
  return newColumns.map((col, idx) => ({ ...col, order: idx }));
};
